document.addEventListener('DOMContentLoaded', () => {
  const seccion = document.querySelector('.creador-combos-seccion');
  if (!seccion) return;

  const cards = seccion.querySelectorAll('.combo-card-producto');
  const listaResumen = seccion.querySelector('#ComboListaItemsJS');
  const txtPrecioFinal = seccion.querySelector('#ComboPrecioFinalJS');
  const btnSubmit = seccion.querySelector('#ComboSubmitGlobalJS');

  function actualizarCombo() {
    listaResumen.innerHTML = '';
    let sumaSubtotal = 0;
    let contadorActivos = 0;

    cards.forEach(card => {
      if (card.classList.contains('active-in-combo')) {
        contadorActivos++;
        const id = card.getAttribute('data-id');
        const price = parseFloat(card.getAttribute('data-price')) / 100;
        const title = card.getAttribute('data-title');
        const sku = card.getAttribute('data-sku');
        const meta = card.getAttribute('data-meta');
        const img = card.getAttribute('data-img');

        sumaSubtotal += price;

        const itemHTML = `
          <div class="resumen-item-linea" data-resumen-id="${id}">
            <img src="${img}" alt="${title}" width="50" height="50" loading="lazy">
            <div class="resumen-item-info">
              <h5 class="resumen-item-nombre">${title}</h5>
              <p class="resumen-item-sku">${sku}</p>
              <p class="resumen-item-meta">${meta}</p>
            </div>
          </div>
        `;
        listaResumen.insertAdjacentHTML('beforeend', itemHTML);
      }
    });

    // Suma e impresión directa en la tarjeta de resumen
    txtPrecioFinal.textContent = `$${sumaSubtotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;

    // Habilitar o deshabilitar el botón de compra global
    btnSubmit.disabled = (contadorActivos === 0);
    btnSubmit.style.opacity = (contadorActivos === 0) ? '0.4' : '1';
  }

  // Escuchador de clics para prender y apagar los productos correctamente
  cards.forEach(card => {
    const btnToggle = card.querySelector('.combo-card-btn-toggle');
    btnToggle.addEventListener('click', () => {
      card.classList.toggle('active-in-combo');
      actualizarCombo();
    });
  });

  // Envío en lote al carrito de Shopify
  btnSubmit.addEventListener('click', async () => {
    btnSubmit.disabled = true;
    btnSubmit.style.opacity = '0.5';

    const itemsToCart = [];
    cards.forEach(card => {
      if (card.classList.contains('active-in-combo')) {
        itemsToCart.push({ id: parseInt(card.getAttribute('data-id')), quantity: 1 });
      }
    });

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToCart })
      });
      if (res.ok) {
        window.location.href = '/cart';
      } else {
        alert('Ocurrió un problema agregando el combo al carrito.');
        btnSubmit.disabled = false;
        btnSubmit.style.opacity = '1';
      }
    } catch (err) {
      console.error(err);
      btnSubmit.disabled = false;
      btnSubmit.style.opacity = '1';
    }
  });

  // Soporte exclusivo para el Diseñador Visual de Shopify
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      if (e.target.querySelector('.creador-combos-container')) {
        window.location.reload();
      }
    });
  }

  // Ejecución inicial automática al cargar
  actualizarCombo();
});
